/**
 * Indiana Jerky — Premium Scroll Animation System
 * Inspired by Stone Sip / TheOak Webflow aesthetics
 * Framework-free, GPU-accelerated, production-ready
 */

/* ============================================================
   Inject base animation CSS
   ============================================================ */
(function injectAnimationStyles() {
  if (document.getElementById('ij-animation-styles')) return;

  const style = document.createElement('style');
  style.id = 'ij-animation-styles';
  style.textContent = `
    /* ── Shared initial states ────────────────────────────────── */
    [data-animate],
    [data-text-reveal],
    [data-line-reveal],
    [data-char-split] {
      will-change: transform, opacity;
    }

    /* ── Fade Up ──────────────────────────────────────────────── */
    [data-animate="fade-up"] {
      opacity: 0;
      transform: translate3d(0, 50px, 0);
      transition:
        opacity 0.8s cubic-bezier(0.16, 1, 0.3, 1),
        transform 0.8s cubic-bezier(0.16, 1, 0.3, 1);
    }
    [data-animate="fade-up"].is-visible {
      opacity: 1;
      transform: translate3d(0, 0, 0);
    }

    /* ── Fade In ──────────────────────────────────────────────── */
    [data-animate="fade-in"] {
      opacity: 0;
      transition: opacity 0.6s cubic-bezier(0.16, 1, 0.3, 1);
    }
    [data-animate="fade-in"].is-visible {
      opacity: 1;
    }

    /* ── Scale In ─────────────────────────────────────────────── */
    [data-animate="scale-in"] {
      opacity: 0;
      transform: scale3d(0.85, 0.85, 1);
      transition:
        opacity 0.7s cubic-bezier(0.16, 1, 0.3, 1),
        transform 0.7s cubic-bezier(0.16, 1, 0.3, 1);
    }
    [data-animate="scale-in"].is-visible {
      opacity: 1;
      transform: scale3d(1, 1, 1);
    }

    /* ── Slide Left ───────────────────────────────────────────── */
    [data-animate="slide-left"] {
      opacity: 0;
      transform: translate3d(-60px, 0, 0);
      transition:
        opacity 0.8s cubic-bezier(0.16, 1, 0.3, 1),
        transform 0.8s cubic-bezier(0.16, 1, 0.3, 1);
    }
    [data-animate="slide-left"].is-visible {
      opacity: 1;
      transform: translate3d(0, 0, 0);
    }

    /* ── Slide Right ──────────────────────────────────────────── */
    [data-animate="slide-right"] {
      opacity: 0;
      transform: translate3d(60px, 0, 0);
      transition:
        opacity 0.8s cubic-bezier(0.16, 1, 0.3, 1),
        transform 0.8s cubic-bezier(0.16, 1, 0.3, 1);
    }
    [data-animate="slide-right"].is-visible {
      opacity: 1;
      transform: translate3d(0, 0, 0);
    }

    /* ── Clip Reveal ──────────────────────────────────────────── */
    [data-animate="clip-reveal"] {
      clip-path: inset(100% 0 0 0);
      transition: clip-path 0.9s cubic-bezier(0.16, 1, 0.3, 1);
    }
    [data-animate="clip-reveal"].is-visible {
      clip-path: inset(0% 0 0 0);
    }

    /* ── Reveal Left (horizontal line grow) ───────────────────── */
    [data-animate="reveal-left"] {
      transform-origin: left center;
      transform: scale3d(0, 1, 1);
      transition: transform 0.9s cubic-bezier(0.16, 1, 0.3, 1);
    }
    [data-animate="reveal-left"].is-visible {
      transform: scale3d(1, 1, 1);
    }

    /* ── Stagger Children ─────────────────────────────────────── */
    [data-stagger] > * {
      opacity: 0;
      transform: translate3d(0, 28px, 0);
      transition:
        opacity 0.65s cubic-bezier(0.16, 1, 0.3, 1),
        transform 0.65s cubic-bezier(0.16, 1, 0.3, 1);
    }
    [data-stagger].is-visible > * {
      opacity: 1;
      transform: translate3d(0, 0, 0);
    }

    /* ── Text Reveal (Word Split) ─────────────────────────────── */
    [data-text-reveal] .word-wrap {
      display: inline-block;
      overflow: hidden;
      vertical-align: bottom;
      /* prevent collapsing on whitespace */
      padding-bottom: 0.08em;
      margin-bottom: -0.08em;
    }
    [data-text-reveal] .word-inner {
      display: inline-block;
      transform: translate3d(0, 110%, 0);
      transition: transform 0.75s cubic-bezier(0.16, 1, 0.3, 1);
    }
    [data-text-reveal].is-visible .word-inner {
      transform: translate3d(0, 0, 0);
    }

    /* ── Text Reveal (Line Split) ─────────────────────────────── */
    [data-line-reveal] .line-wrap {
      display: block;
      overflow: hidden;
      padding-bottom: 0.06em;
      margin-bottom: -0.06em;
    }
    [data-line-reveal] .line-inner {
      display: block;
      transform: translate3d(0, 105%, 0);
      transition: transform 0.85s cubic-bezier(0.16, 1, 0.3, 1);
    }
    [data-line-reveal].is-visible .line-inner {
      transform: translate3d(0, 0, 0);
    }

    /* ── Char Split ───────────────────────────────────────────── */
    [data-char-split] .char-wrap {
      display: inline-block;
      overflow: hidden;
      vertical-align: bottom;
    }
    [data-char-split] .char-inner {
      display: inline-block;
      transform: translate3d(0, 100%, 0) rotate(8deg);
      opacity: 0;
      transition:
        transform 0.6s cubic-bezier(0.16, 1, 0.3, 1),
        opacity 0.4s ease;
    }
    /* Preserve spaces */
    [data-char-split] .char-space {
      display: inline-block;
      width: 0.3em;
    }
    [data-char-split].is-visible .char-inner {
      transform: translate3d(0, 0, 0) rotate(0deg);
      opacity: 1;
    }

    /* ── Counter ──────────────────────────────────────────────── */
    [data-count-up] {
      /* no hide state needed — counts from 0 on scroll */
    }

    /* ── Reduced Motion override ──────────────────────────────── */
    @media (prefers-reduced-motion: reduce) {
      [data-animate],
      [data-stagger] > *,
      [data-text-reveal] .word-inner,
      [data-line-reveal] .line-inner,
      [data-char-split] .char-inner {
        opacity: 1 !important;
        transform: none !important;
        clip-path: none !important;
        transition: none !important;
        animation: none !important;
      }
      [data-parallax] {
        transform: none !important;
      }
    }
  `;
  document.head.appendChild(style);
})();


/* ============================================================
   Utility helpers
   ============================================================ */

/** True when the user prefers reduced motion */
const prefersReducedMotion = () =>
  window.matchMedia('(prefers-reduced-motion: reduce)').matches;

/**
 * Trigger an element's entrance animation with an optional delay.
 * @param {Element} el
 * @param {number} [extraDelay=0] - Additional ms on top of data-delay
 */
function triggerEntrance(el, extraDelay = 0) {
  const dataDelay = parseInt(el.dataset.delay || 0, 10);
  const total = dataDelay + extraDelay;

  if (total > 0) {
    setTimeout(() => el.classList.add('is-visible'), total);
  } else {
    el.classList.add('is-visible');
  }
}

/**
 * Create an IntersectionObserver that fires once per element.
 * @param {function} callback - (entry, observer) => void
 * @param {IntersectionObserverInit} [options]
 */
function createObserver(callback, options = {}) {
  const defaults = { threshold: 0.15 };
  return new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        callback(entry, observer);
        observer.unobserve(entry.target);
      }
    });
  }, { ...defaults, ...options });
}


/* ============================================================
   Animation Module
   ============================================================ */

class ScrollAnimations {
  constructor() {
    this._observers = [];
    this._scrollListeners = [];
    this.init();
  }

  init() {
    this.initStandardAnimations();
    this.initStaggerChildren();
    this.initTextRevealWord();
    this.initTextRevealLine();
    this.initCharSplit();
    this.initParallax();
    this.initScrollZoom();
    this.initCountUp();
  }

  /** Tear down all observers & listeners (used before re-init) */
  destroy() {
    this._observers.forEach(obs => obs.disconnect());
    this._observers = [];
    this._scrollListeners.forEach(fn => window.removeEventListener('scroll', fn));
    this._scrollListeners = [];
  }

  /* ----------------------------------------------------------
     1. Standard data-animate elements
        fade-up | fade-in | scale-in | slide-left | slide-right
        clip-reveal | reveal-left
     ---------------------------------------------------------- */
  initStandardAnimations() {
    const selectors = [
      'fade-up', 'fade-in', 'scale-in',
      'slide-left', 'slide-right',
      'clip-reveal', 'reveal-left',
    ].map(v => `[data-animate="${v}"]`).join(',');

    const elements = document.querySelectorAll(selectors);
    if (!elements.length) return;

    // Large elements (clip-reveal, reveal-left) get a lower threshold
    const largeTypes = new Set(['clip-reveal', 'reveal-left']);

    const standardObs = createObserver((entry) => {
      triggerEntrance(entry.target);
    }, { threshold: 0.15 });

    const largeObs = createObserver((entry) => {
      triggerEntrance(entry.target);
    }, { threshold: 0.05 });

    this._observers.push(standardObs, largeObs);

    elements.forEach(el => {
      const type = el.dataset.animate;
      if (largeTypes.has(type)) {
        largeObs.observe(el);
      } else {
        standardObs.observe(el);
      }
    });
  }

  /* ----------------------------------------------------------
     2. Stagger children: [data-stagger]
     ---------------------------------------------------------- */
  initStaggerChildren() {
    const parents = document.querySelectorAll('[data-stagger]');
    if (!parents.length) return;

    const obs = createObserver((entry) => {
      const parent = entry.target;
      const staggerDelay = parseInt(parent.dataset.staggerDelay || 80, 10);
      const baseDelay = parseInt(parent.dataset.delay || 0, 10);

      Array.from(parent.children).forEach((child, i) => {
        child.style.transitionDelay = `${baseDelay + i * staggerDelay}ms`;
      });

      parent.classList.add('is-visible');
    }, { threshold: 0.1 });

    this._observers.push(obs);
    parents.forEach(el => obs.observe(el));
  }

  /* ----------------------------------------------------------
     3. Text Reveal — Word Split: [data-text-reveal]
        Each word gets: <span class="word-wrap"><span class="word-inner">word</span></span>
     ---------------------------------------------------------- */
  initTextRevealWord() {
    const elements = document.querySelectorAll('[data-text-reveal]');
    if (!elements.length) return;

    elements.forEach(el => {
      // Skip if already split
      if (el.dataset.splitDone) return;
      el.dataset.splitDone = '1';

      const originalText = el.textContent;
      el.setAttribute('aria-label', originalText.trim());

      const words = originalText.split(/(\s+)/);
      const staggerMs = parseInt(el.dataset.textRevealDelay || 55, 10);

      let wordIndex = 0;
      el.innerHTML = words.map(token => {
        // Preserve pure whitespace tokens as non-breaking spaces
        if (/^\s+$/.test(token)) {
          return `<span class="word-wrap" aria-hidden="true"><span class="word-inner">&nbsp;</span></span>`;
        }
        const delay = wordIndex * staggerMs;
        wordIndex++;
        return `<span class="word-wrap" aria-hidden="true"><span class="word-inner" style="transition-delay:${delay}ms">${token}</span></span>`;
      }).join('');
    });

    const obs = createObserver((entry) => {
      triggerEntrance(entry.target);
    }, { threshold: 0.2 });

    this._observers.push(obs);
    elements.forEach(el => obs.observe(el));
  }

  /* ----------------------------------------------------------
     4. Text Reveal — Line Split: [data-line-reveal]
        Splits text into lines by measuring rendered width.
        Falls back to word-split groups when ResizeObserver unavailable.
     ---------------------------------------------------------- */
  initTextRevealLine() {
    const elements = document.querySelectorAll('[data-line-reveal]');
    if (!elements.length) return;

    const splitIntoLines = (el) => {
      if (el.dataset.splitDone) {
        // Clear previous split
        el.innerHTML = el.getAttribute('data-original-text') || el.textContent;
        delete el.dataset.splitDone;
      }

      const originalText = el.textContent.trim();
      el.setAttribute('aria-label', originalText);
      el.setAttribute('data-original-text', originalText);

      // Measure by injecting words one by one into a hidden clone
      const words = originalText.split(/\s+/);
      const staggerMs = parseInt(el.dataset.lineRevealDelay || 120, 10);

      // Build word spans to detect line breaks
      el.innerHTML = words.map(w => `<span class="word-measure">${w} </span>`).join('');

      const spans = Array.from(el.querySelectorAll('.word-measure'));
      const lines = [];
      let currentLine = [];
      let lastTop = null;

      spans.forEach(span => {
        const top = span.getBoundingClientRect().top;
        if (lastTop === null) lastTop = top;
        if (Math.abs(top - lastTop) > 2) {
          if (currentLine.length) lines.push(currentLine.map(s => s.textContent.trim()).join(' '));
          currentLine = [];
          lastTop = top;
        }
        currentLine.push(span);
      });
      if (currentLine.length) lines.push(currentLine.map(s => s.textContent.trim()).join(' '));

      el.innerHTML = lines.map((line, i) =>
        `<span class="line-wrap" aria-hidden="true"><span class="line-inner" style="transition-delay:${i * staggerMs}ms">${line}</span></span>`
      ).join('');

      el.dataset.splitDone = '1';
    };

    elements.forEach(el => splitIntoLines(el));

    const obs = createObserver((entry) => {
      triggerEntrance(entry.target);
    }, { threshold: 0.15 });

    this._observers.push(obs);
    elements.forEach(el => obs.observe(el));
  }

  /* ----------------------------------------------------------
     5. Char Split: [data-char-split]
        Splits into individual characters with staggered
        translateY + rotation entrance.
     ---------------------------------------------------------- */
  initCharSplit() {
    const elements = document.querySelectorAll('[data-char-split]');
    if (!elements.length) return;

    elements.forEach(el => {
      if (el.dataset.splitDone) return;
      el.dataset.splitDone = '1';

      const originalText = el.textContent;
      el.setAttribute('aria-label', originalText.trim());

      const staggerMs = parseInt(el.dataset.charDelay || 35, 10);
      let charIndex = 0;

      const html = originalText.split('').map(char => {
        if (char === ' ') {
          return `<span class="char-space" aria-hidden="true"> </span>`;
        }
        const delay = charIndex * staggerMs;
        charIndex++;
        return `<span class="char-wrap" aria-hidden="true"><span class="char-inner" style="transition-delay:${delay}ms">${char}</span></span>`;
      }).join('');

      el.innerHTML = html;
    });

    const obs = createObserver((entry) => {
      triggerEntrance(entry.target);
    }, { threshold: 0.2 });

    this._observers.push(obs);
    elements.forEach(el => obs.observe(el));
  }

  /* ----------------------------------------------------------
     6. Parallax: [data-parallax]
        data-parallax-speed: float, default 0.15
        Positive = slower than scroll (moves up), negative = faster
     ---------------------------------------------------------- */
  initParallax() {
    const elements = document.querySelectorAll('[data-parallax]');
    if (!elements.length) return;
    if (prefersReducedMotion()) return;

    let ticking = false;

    const update = () => {
      const wh = window.innerHeight;
      elements.forEach(el => {
        const speed = parseFloat(el.dataset.parallaxSpeed || 0.15);
        const rect = el.getBoundingClientRect();
        if (rect.bottom < 0 || rect.top > wh) return;
        const centerOffset = rect.top + rect.height / 2 - wh / 2;
        const y = centerOffset * speed;
        el.style.transform = `translate3d(0, ${y}px, 0)`;
      });
      ticking = false;
    };

    const onScroll = () => {
      if (!ticking) {
        requestAnimationFrame(update);
        ticking = true;
      }
    };

    window.addEventListener('scroll', onScroll, { passive: true });
    this._scrollListeners.push(onScroll);
    update();
  }

  /* ----------------------------------------------------------
     7. Image Zoom on scroll: [data-scroll-zoom]
        Scales from 1.0 → 1.15 as the section scrolls through viewport
     ---------------------------------------------------------- */
  initScrollZoom() {
    const elements = document.querySelectorAll('[data-scroll-zoom]');
    if (!elements.length) return;
    if (prefersReducedMotion()) return;

    let ticking = false;

    const update = () => {
      const wh = window.innerHeight;
      elements.forEach(el => {
        const rect = el.getBoundingClientRect();
        if (rect.bottom < 0 || rect.top > wh) return;

        // progress: 0 when bottom of element at top of viewport → 1 when top at bottom
        const progress = 1 - (rect.top / (wh + rect.height));
        const clamped = Math.min(Math.max(progress, 0), 1);
        const maxScale = parseFloat(el.dataset.scrollZoomMax || 1.15);
        const scale = 1 + (maxScale - 1) * clamped;

        el.style.transform = `scale3d(${scale}, ${scale}, 1)`;
      });
      ticking = false;
    };

    const onScroll = () => {
      if (!ticking) {
        requestAnimationFrame(update);
        ticking = true;
      }
    };

    window.addEventListener('scroll', onScroll, { passive: true });
    this._scrollListeners.push(onScroll);
    update();
  }

  /* ----------------------------------------------------------
     8. Count Up: [data-count-up]
        data-count-up: target number (or read from textContent)
        data-count-duration: ms, default 1800
        data-count-prefix / data-count-suffix
     ---------------------------------------------------------- */
  initCountUp() {
    const elements = document.querySelectorAll('[data-count-up]');
    if (!elements.length) return;

    const easeOutCubic = t => 1 - Math.pow(1 - t, 3);

    const animateCount = (el) => {
      const rawTarget = el.dataset.countUp || el.textContent;
      const target = parseFloat(rawTarget.replace(/[^0-9.]/g, ''));
      const isFloat = rawTarget.includes('.');
      const decimals = isFloat ? (rawTarget.split('.')[1] || '').length : 0;
      const duration = parseInt(el.dataset.countDuration || 1800, 10);
      const suffix = el.dataset.countSuffix || '';
      const prefix = el.dataset.countPrefix || '';
      const start = performance.now();

      const tick = (now) => {
        const elapsed = now - start;
        const progress = Math.min(elapsed / duration, 1);
        const eased = easeOutCubic(progress);
        const current = eased * target;

        el.textContent = `${prefix}${
          isFloat
            ? current.toFixed(decimals)
            : Math.round(current).toLocaleString()
        }${suffix}`;

        if (progress < 1) requestAnimationFrame(tick);
      };

      requestAnimationFrame(tick);
    };

    const obs = createObserver((entry) => {
      animateCount(entry.target);
    }, { threshold: 0.5 });

    this._observers.push(obs);
    elements.forEach(el => obs.observe(el));
  }
}


/* ============================================================
   Boot & Shopify re-render support
   ============================================================ */

let _animInstance = null;

function bootAnimations() {
  if (prefersReducedMotion()) {
    // Still need to make elements visible for reduced-motion users
    document.querySelectorAll('[data-animate], [data-stagger]').forEach(el => {
      el.classList.add('is-visible');
    });
    return;
  }

  if (_animInstance) _animInstance.destroy();
  _animInstance = new ScrollAnimations();
}

document.addEventListener('DOMContentLoaded', bootAnimations);

// Shopify section reload (theme editor live preview)
document.addEventListener('shopify:section:load', () => {
  // Re-split text elements by clearing their splitDone flag
  document.querySelectorAll('[data-text-reveal], [data-line-reveal], [data-char-split]').forEach(el => {
    delete el.dataset.splitDone;
    el.classList.remove('is-visible');
  });
  document.querySelectorAll('[data-animate], [data-stagger]').forEach(el => {
    el.classList.remove('is-visible');
  });
  bootAnimations();
});
